export const environment = {
  production: false,
  apiURL: "https://dev.gpdone.cloud/api",
  siteBase: "https://dev.gpdone.cloud",
  isTestEnvironment: true
};
